import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { config } from 'api';

import PackInfoShelfLife from 'apps/fops/components/fopPartials/PackInfoShelfLife';
import ExpiryDate from './ExpiryDate';
import DrinkResponsiblyInfo from './DrinkResponsiblyInfo';
import NutritionDataTable from './NutritionDataTable';
import FoodProfileAlert from 'apps/foodProfile/containers/FoodProfileAlert';
import FoodProfileInfo from 'apps/foodProfile/containers/FoodProfileInfo';
import { possibleBadges } from './Badges';

import Accordion from 'widgets/Accordion/Accordion';
import AccordionElement from 'widgets/Accordion/AccordionElement';

export default class ProductInfo extends PureComponent {
  static propTypes = {
    bopFields: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
    isAlcohol: PropTypes.bool,
  };

  state = {
    isMobileBreakpoint: false,
  };

  componentDidMount() {
    this.mq = window.matchMedia(`(max-width: ${config.breakpoints.medium_large})`);
    this.mq.addListener(this.handleMedia);
    this.handleMedia();
  }

  componentWillUnmount() {
    this.mq.removeListener(this.handleMedia);
  }

  handleMedia = () => {
    this.setState({ isMobileBreakpoint: this.mq.matches });
  };

  renderLifestyleBadges = (packInfo) => {
    if (!packInfo) {
      return null;
    }

    const possibleIconNames = possibleBadges && Object.keys(possibleBadges);
    const badges = Object.keys(packInfo)
      .filter(key => possibleIconNames.includes(key));

    const badgesHtml = badges.map(icon => (
      <span
        className="bop-lifestyleBadge"
        key={icon}
      >
        <img
          key={icon}
          src={possibleBadges[icon].icon}
          alt={possibleBadges[icon].description}
          className={`bop-badge bop-badge-${icon}`}
        />
        {possibleBadges[icon].description}
      </span>
    ));

    return <p className="gn-content">{badgesHtml}</p>;
  };

  renderBopFieldContent = (bopField) =>
    bopField.map((block, index) => {
      const { title, content } = block;
      const key = title || `info-block-${index}`;

      return (
        <div className="gn-content bop-info__field" key={key}>
          {title && (<h6>{title}</h6>)}
          <div className="bop-info__content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      );
    });

  // eslint-disable-next-line complexity
  render() {
    const { bopFields = {}, product, isAlcohol, isFoodMaestroEnabled } = this.props;
    if (!Object.keys(bopFields).length) {
      return null;
    }

    const { packInfo = {}, gtin } = product;
    const { minimumShelfLife = 0, averageShelfLife = 0 } = packInfo;
    const { isMobileBreakpoint } = this.state;

    const {
      brandAndManufacturer,
      description,
      ingredients,
      nutrition,
      storageAndUsage,
      productDetails,
    } = bopFields;

    const productDetailsColumn = [
      (!!description && (
        <AccordionElement key="product-description" title="Description" expanded>
          {this.renderBopFieldContent(description)}
          {this.renderLifestyleBadges(packInfo)}
          {isFoodMaestroEnabled && <FoodProfileInfo barcode={gtin} />}
          <div
            id="bopShelfLife"
            className="bop-shelfLife__wrapper"
          >
            <PackInfoShelfLife packInfo={packInfo} className="bop-shelfLife bop-shelfLife--withDescription" />
            <ExpiryDate minimumShelfLife={minimumShelfLife} averageShelfLife={averageShelfLife} />
          </div>
        </AccordionElement>
      )),
      (!!storageAndUsage && (
        <AccordionElement
          key="product-storage"
          title="Usage"
          expanded={!description && !isMobileBreakpoint}
        >
          {this.renderBopFieldContent(storageAndUsage)}
        </AccordionElement>
      )),
      (!!brandAndManufacturer && (
        <AccordionElement key="product-brand" title="Brand details">
          {this.renderBopFieldContent(brandAndManufacturer)}
        </AccordionElement>
      )),
    ];

    const nutritionDetailsColumn = [
      (!!nutrition && (
        <AccordionElement key="product-nutrition" title="Nutrition" expanded={!isMobileBreakpoint}>
          <NutritionDataTable nutritionData={nutrition} />
        </AccordionElement>
      )),
      (!!ingredients && (
        <AccordionElement key="product-ingredients" title="Ingredients" expanded={!isMobileBreakpoint}>
          {this.renderBopFieldContent(ingredients)}
        </AccordionElement>
      )),
      (!!productDetails && (
        <AccordionElement key="details" title="Product details" expanded={!isMobileBreakpoint}>
          {this.renderBopFieldContent(productDetails)}
          {isAlcohol && <DrinkResponsiblyInfo />}
        </AccordionElement>
      )),
    ];

    return (
      <section id="productInformation" className="bop-section bop-productInformation">
        <h3 className="bop-productInfo__header">Product information</h3>
        <div className="gn-divider bop-productInfo__divider" />
        {!isMobileBreakpoint && (
          <>
            <Accordion className="bop-section bop-productDetails">
              { productDetailsColumn }
            </Accordion>
            <div className="bop-section bop-nutritionDetails">
              <Accordion>
                { nutritionDetailsColumn }
              </Accordion>
              {isFoodMaestroEnabled && <FoodProfileAlert barcode={product.gtin} />}
            </div>
          </>
        )}
        {isMobileBreakpoint && (
          <>
            <Accordion className="bop-section bop-productDetails">
              { [...productDetailsColumn, ...nutritionDetailsColumn] }
            </Accordion>
            {isFoodMaestroEnabled && <FoodProfileAlert barcode={product.gtin} />}
          </>
        )}
      </section>
    );
  }
}
